"use client";
// components/InactivityTimeoutProvider.tsx - 12시간 비활성 자동 로그아웃 프로바이더

import { useEffect } from 'react';
import { useInactivityTimeout } from '@/hooks/useInactivityTimeout';
import { useAuth } from '@/context/AuthContext';
import { getInactivityConfig } from '@/lib/auth/security-config';

interface InactivityTimeoutProviderProps {
  children: React.ReactNode;
}

export default function InactivityTimeoutProvider({ children }: InactivityTimeoutProviderProps) {
  const { isAuthenticated } = useAuth();

  // 설정에서 기본값 가져오기
  const defaultConfig = getInactivityConfig();
  
  // 12시간 비활성 자동 로그아웃 설정
  const {
    getInactiveTime,
    isWarningShown,
    isMobile,
    timeoutHours,
    warningMinutes
  } = useInactivityTimeout({
    timeoutHours: defaultConfig.TIMEOUT_HOURS,
    warningMinutes: defaultConfig.WARNING_MINUTES,
    enabled: isAuthenticated // 로그인된 사용자에게만 적용
  });

  // 개발 환경에서 디버깅 정보 표시
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && isAuthenticated) {
      const debugInterval = setInterval(() => {
        const inactiveTime = getInactiveTime();
        console.log(`[Inactivity Debug] 비활성 시간: ${inactiveTime.formatted}`);
        console.log(`[Inactivity Debug] 모바일: ${isMobile}`);
        console.log(`[Inactivity Debug] 경고 표시: ${isWarningShown}`);
      }, 60000); // 1분마다 로그

      return () => clearInterval(debugInterval);
    }
  }, [isAuthenticated, getInactiveTime, isMobile, isWarningShown]);

  // 개발 환경에서 상태 표시 (선택적)
  if (process.env.NODE_ENV === 'development' && isAuthenticated) {
    return (
      <>
        {children}
        {/* Debug info only shown in development */}
        <div className="fixed top-4 left-4 bg-black bg-opacity-75 text-white p-2 rounded text-xs z-50">
          <div>Inactive: {getInactiveTime().formatted}</div>
          <div>Mobile: {isMobile ? 'Yes' : 'No'}</div>
          <div>Warning: {isWarningShown ? 'Yes' : 'No'}</div>
          <div>Timeout: {timeoutHours}h</div>
          <div>Warning: {warningMinutes}m before</div>
        </div>
      </>
    );
  }

  return <>{children}</>;
} 